module.exports = "/images/img-4.png?b28675835d84804533fc87e6ff39de22";